export default __webpack_public_path__ + "static/media/4w.5ffbcefa.svg";